var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('div',{staticClass:"accordion-head",class:{ active: _vm.visible },on:{"click":_vm.open}},[_vm._t("accordion-head"),_c('i',{class:_vm.$props.toggleIcon})],2),_c('SlideUpDown',{attrs:{"active":_vm.visible,"duration":300}},[_c('div',{staticClass:"accordion-body"},[_vm._t("accordion-body")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }